import ApiService from '@/common/api.service'

export default {
  uploadSchedule (payload) {
    return new Promise((resolve, reject) => {
      ApiService.post('/schedule/upload', payload).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  deletesSchedule (payload) {
    return new Promise((resolve, reject) => {
      ApiService.post('document/deleteSchedule', payload).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getScheduleList (id) {
    return new Promise((resolve, reject) => {
      ApiService.query('/tax-return-schedule/admin/list/' + id).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  publishSchedule (id, ankenId) {
    return new Promise((resolve, reject) => {
      ApiService.post(`/tax-return-schedule/publish/${id}/anken/${ankenId}`).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getPublishFile (id) {
    return new Promise((resolve, reject) => {
      ApiService.query('/tax-return-schedule/publishFile/' + id).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getSignedUrl (payload) {
    return new Promise((resolve, reject) => {
      ApiService.post('/document/getSignedUrl', payload).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  cancelPublicFile (id) {
    return new Promise((resolve, reject) => {
      ApiService.post('/tax-return-schedule/publishOff/' + id).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  ckeS3upload (file, functionId) {
    return new Promise((resolve, reject) => {
      ApiService.post('/document/public/ckeS3upload', { ...file, functionId }).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  updateNoticeOff (id) {
      return new Promise((resolve, reject) => {
        ApiService.query('/document/updateNoticeOff/' + id).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
  getRequiredDocument (SpDocumentListReq) {
      return new Promise((resolve, reject) => {
          ApiService.post('requiredDocument/memberList', SpDocumentListReq).then(response => {
              resolve(response)
          }).catch(error => {
              reject(error)
          })
      })
  },
  getRequiredDocumentAdmin (SpDocumentListReq) {
      return new Promise((resolve, reject) => {
          ApiService.post('requiredDocument/adminList', SpDocumentListReq).then(response => {
            resolve(response)
          }).catch(error => {
            reject(error)
          })
      })
  },
  changeMemberMemo (ChangeAdminMemoRequest) {
      return new Promise((resolve, reject) => {
          ApiService.post('requiredDocument/changeMemberMemo', ChangeAdminMemoRequest).then(response => {
              resolve(response)
          }).catch(error => {
              reject(error)
          })
      })
  },
  changeAdminMemo (ChangeAdminMemoRequest) {
      return new Promise((resolve, reject) => {
          ApiService.post('requiredDocument/changeAdminMemo', ChangeAdminMemoRequest).then(response => {
              resolve(response)
          }).catch(error => {
              reject(error)
          })
      })
  }
}
